'use client';
import { useRouter } from 'next/navigation';
import { useState, FC } from 'react';
import { Flex, Text, Button } from '@eqi-investimentos/react';
import {
  SliderInput,
  SliderInputProps,
} from '@/components/atoms/Slider/SliderInput';
import { useT } from '@/libs/i18n/utils/useT';
import { PATHS } from '@/config/paths';
import { ProfileSelectRadio } from '../ProfileSelectRadio/index';

export const SliderFormSimulation: FC = () => {
  const t = useT();

  const router = useRouter();

  const [riskProfile, setRiskProfile] = useState<string>(
    t(`screens.calculadora-viver-de-renda.profiles.profile02.value`)
  );
  const [desiredIncome, setDesiredIncome] = useState<number>(1000);

  const sliderConfig: Omit<SliderInputProps, 'onChange'> = {
    label: t('screens.calculadora-viver-de-renda.desiredIncome'),
    min: 1000,
    max: 200000,
    isMonetary: true,
    step: 100,
    marks: [{ value: 1000 }, { value: 200000, ml: '-3.5rem' }],
  };

  const handleSimulate = () => {
    router.push(
      `${PATHS.lp.riCalculatorSimulation}?desiredMonthlyIncome=${desiredIncome}&riskProfile=${riskProfile}`
    );
  };

  const handleChangeSlider = (value: number) => {
    setDesiredIncome(value);
  };

  const handleChangeProfile = (value: string) => {
    setRiskProfile(value);
  };

  return (
    <Flex
      alignItems="center"
      p="2xl"
      gap="3xl"
      borderRadius="xs"
      w="fit-content"
      h="fit-content"
      bg="background.primary"
      alignSelf="center"
    >
      <Flex as="form" flexDir="column" gap="xl" w="24rem" h="full">
        <Text size="2xl" fontWeight={600}>
          {t('screens.calculadora-viver-de-renda.subTitle')}
        </Text>
        <SliderInput
          {...sliderConfig}
          onChange={handleChangeSlider}
        ></SliderInput>
        <Text size="lg">
          {t('screens.calculadora-viver-de-renda.whatsYourProfile')}
        </Text>
        <Flex flexDir="column" w="full" h="fit-content" gap="s">
          <ProfileSelectRadio onChange={handleChangeProfile} />
        </Flex>
        <Button w="full" size="lg" onClick={handleSimulate}>
          <Text size="lg">{t('screens.calculadora-viver-de-renda.cta')}</Text>
        </Button>
      </Flex>
    </Flex>
  );
};
